import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function PenaltyNoticeList(props) {
  const Config = {
    purchase: {
      title: '供应商违约/索赔通知',
      apiPath: '/b2bPunishNotice/pageList',
      enumMainKey: '',
      companyNameKey: 'companyName',
      orderProperty: 'createTime',
      detailLink: '/mp/purchase/supplier/penalty-notice/detail',
      searchBarPlaceholder: '通知标题、供应商名称、编码查询',
      tabs: ['全部', '待确认'],
      countApi: '',
      arrEnumField: [
        {
          mainKey: 'B02_punish_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a } = data;
        setCount([undefined, a]);
      },
      tabConfig: [
        undefined, //全部
        1 // 待确认
      ]
    },
    sale: {
      title: '供应商违约/索赔通知',
      apiPath: '/b2bCustomerPunishNotice/pageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      orderProperty: 'createTime',
      detailLink: '/mp/sale/customer/penalty-notice/detail',
      searchBarPlaceholder: '通知标题、供应商名称、编码查询',
      tabs: ['全部', '待确认'],
      countApi: '',
      arrEnumField: [
        {
          mainKey: 'B02_punish_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a } = data;
        setCount([undefined, a]);
      },
      tabConfig: [
        undefined, //全部
        1 // 待确认
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        status: config.tabConfig[currentTab]
      };
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.pnhXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.pnhXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('penalty', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>通知标题</label>
                          <div>{item.punishTitle}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                        <li>
                          <label>绩效扣分</label>
                          <div>
                            {formatNumber(
                              item.totDeductAssessmentScore,
                              item.QTY
                            )}
                          </div>
                        </li>
                        <li>
                          <label>罚款金额</label>
                          <div>
                            {formatNumber(item.totDeductAmount, item.AMOUNT)}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PenaltyNoticeList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PenaltyNoticeList);
